export const sharedConstants = {
    MASTER_STATES_REQUEST        : 'MASTER_STATES_REQUEST',
    MASTER_STATES_SUCCESS        : 'MASTER_STATES_SUCCESS',
    MASTER_STATES_FAILURE        : 'MASTER_STATES_FAILURE',
};